<template>
  <footer class="com" :class="{ dashboard: dashboard }">
    <div class="txt">GOT MOLD?&#174; is a registered trademark</div>
    <div class="txt">of MycoLab USA, Inc &#8226; Copyright &#169; {{year}}</div>
    <div class="link-wrapper">
      <span class="footer-rights">All Rights Reserved</span>
      <button
        @click.stop="stopPropagation"
        @click="prevent()"
        class="footer-link"
      >
        Privacy Policy
      </button>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      dashboard: false,
      year:new Date().getFullYear(),
    };
  },
  methods: {
    prevent() {
      this.$emit("showPrivecy", true);
    },
    stopPropagation(event) {
      event.stopPropagation();
    }
  },
  watch: {
    $route(to, from) {
      to.name === "Home" || to.name === "ProjectInfo"
        ? (this.dashboard = true)
        : (this.dashboard = false);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/colors";
.com {
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 0;
  width: 100%;
  position: relative;
  padding: 15px 0 20px 0;
  background-color: transparent;
}
.com.dashboard {
  position: relative;
  background-color: #f4f8f9;
  bottom: 0;
  padding: 20px 0;
}
.txt {
  font-size: 14px;
  font-family: TTNormsRegular, sans-serif;
  color: #000;
  margin: 0 2px 0 0;
  text-align: center;
}
.link-wrapper {
  display: flex;
}
.footer-link,
.footer-rights {
  color: #000;
  border: 1px solid transparent;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  font-family: TTNormsRegular, sans-serif;
  font-size: 14px;
}
.footer-link {
  cursor: pointer;
}

@media (max-width: 768px) {
  .com {
    padding: 10px 0;
    flex-direction: column;
    background-color: #3391d1;
    .txt {
      color: #fefefe;
    }
    .link-wrapper {
      display: flex;
    }
    .footer-link,
    .footer-rights {
      margin: 5px 0 0 0;
      color: #fefefe;
    }
  }

  .dashboard {
    .txt,
    .footer-link,
    .footer-rights {
      color: $gray;
    }
  }
}
</style>
